import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[WorkOrderStatus SetFilter] Action',
  ResetFilter: '[WorkOrderStatus ResetFilter] Action',
}

const initialWorkOrderStatusState: IWorkOrderStatusState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IWorkOrderStatusState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-WorkOrderStatus', whitelist: ['filter']},
  (
    state: IWorkOrderStatusState = initialWorkOrderStatusState,
    action: ActionWithPayload<IWorkOrderStatusState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialWorkOrderStatusState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
